export const GET_WEATHER_DATA  =  'GET_WEATHER_DATA'; 

export const GET_TIME  = 'GET_TIME';

export const GET_LOCATION_DATA = 'GET_LOCATION_DATA';